// Const
import {
  GET_FLEETS,
  UPDATE_FLEET,
  GET_VEHICLE_PREFERRED_SOURCES,
  GET_CENTERS,
  UPDATE_VEHICLE_PREFERRED_SOURCES,
  GET_FLEET_SHIFTS,
  UPDATE_FLEET_SHIFTS,
  UPDATE_FLEET_STATUS, GET_FLEET, CREATE_FLEETS,
} from './constants';

// Type
import {Payload, Fleet, FleetShift} from './interfaces';

export function getFleetsAction(payload: Payload) {
  return {
    type: GET_FLEETS,
    payload,
  };
}

export function createFleetsAction(payload: Payload) {
  return {
    type: CREATE_FLEETS,
    payload,
  };
}

export function getFleetAction(payload: Payload) {
  return {
    type: GET_FLEET,
    payload,
  };
}

export function updateFleetActions(payload: Payload) {
  return {
    type: UPDATE_FLEET,
    payload,
  };
}

export function updateFleetStatusActions(payload: Payload) {
  return {
    type: UPDATE_FLEET_STATUS,
    payload,
  };
}

export function getVehiclePreferredSourcesAction(id: number) {
  return {
    type: GET_VEHICLE_PREFERRED_SOURCES,
    payload: id,
  };
}

export function updateVehiclePreferredSourcesAction(payload: {
  id: number;
  body: number[];
}) {
  return {
    type: UPDATE_VEHICLE_PREFERRED_SOURCES,
    payload,
  };
}

export function getAllCentersAction() {
  return {
    type: GET_CENTERS,
  };
}

export function getFleetShiftsAction(payload: {id: number}) {
  return {
    type: GET_FLEET_SHIFTS,
    payload,
  };
}

export function updateFleetShiftsAction(payload: {body: FleetShift}) {
  return {
    type: UPDATE_FLEET_SHIFTS,
    payload,
  };
}
